import {
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Link,
  Text,
  VStack,
  useBreakpointValue,
  useToast
} from "@chakra-ui/react";
import { useState } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import axiosInstance from "../../config/axiosInstance";

const Login = () => {
  const boxWidth = useBreakpointValue({ base: "90%", sm: "xs", md: "md" });
  const toast = useToast();
  const navigate = useNavigate();

  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleLogin = async () => {
    if (!phone || !password) {
      return toast({
        title: "Please enter phone number and password.",
        status: "warning",
        isClosable: true,
      });
    }

    if (phone.length < 10) {
      return toast({
        title: "Phone number must be at least 10 digits.",
        status: "warning",
        isClosable: true,
      });
    }

    if (password.length < 6) {
      return toast({
        title: "Password must be at least 6 characters.",
        status: "warning",
        isClosable: true,
      });
    }

    setIsSubmitting(true);
    try {
      const res = await axiosInstance.post("/api/auth/login", {
        phone: phone.trim(), // ✅ Sending phone instead of email
        password,
      });

      const { token, user } = res.data;

      localStorage.setItem("token", token);
      localStorage.setItem("role", user.role);

      navigate("/dashboard");

      toast({
        title: "Login successful!",
        status: "success",
        isClosable: true,
      });
    } catch (err) {
      toast({
        title: err.response?.data?.message || "Login failed",
        status: "error",
        isClosable: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Flex
      minH="100vh"
      bg="gray.50"
      px={2}
      justify="center"
      align="start"
      pt={12}
    >
      <Box
        bg="white"
        w={boxWidth}
        rounded="md"
        p={{ base: 4, md: 6 }}
        boxShadow="md"
        pt={8}
      >
        <VStack spacing={4} align="stretch">
          <Heading fontSize={{ base: "xl", md: "2xl" }} textAlign="center">
            Sign In
          </Heading>

          <Text fontSize="xs" textAlign="center">
            Create a new Admin account?{" "}
            <Link as={RouterLink} to="/create" color="blue.500" fontSize="xs">
              Sign Up
            </Link>
          </Text>

          {/* Phone Input */}
          <FormControl>
            <FormLabel fontSize="xs">Phone Number</FormLabel>
            <Input
              size="sm"
              placeholder="Enter Phone Number"
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </FormControl>

          {/* Password Input */}
          <FormControl>
            <FormLabel fontSize="xs">Password</FormLabel>
            <Input
              size="sm"
              placeholder="Enter Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </FormControl>

          <Checkbox size="sm" fontSize="xs">
            Keep me signed in
          </Checkbox>

          <Button
            size="sm"
            color="white"
            bg="#005738"
            _hover={{ bg: "#00462d" }}
            w="full"
            isLoading={isSubmitting}
            onClick={handleLogin}
          >
            Sign In
          </Button>

          <Link
            fontSize="xs"
            color="blue.500"
            textAlign="center"
            href="/forgot"
          >
            Forgot your password?
          </Link>
        </VStack>
      </Box>
    </Flex>
  );
};

export default Login;
